import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-body mt-3 d-flex flex-column justify-content-start align-content-start px-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-start mb-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-4 fw-bold content-title" }, "帳務管理")
], -1)

import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import ScheduleCheckMgmt from "@/components/ScheduleCheckMgmt.vue";
import CloseAccountDataMgmt from "@/components/CloseAccountDataMgmt.vue";
import ReportMgmt from "@/components/ReportMgmt.vue";
import { useUserInfoStore } from "@/stores/UserInfoStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'MusicCloseAccountMgmt',
  setup(__props) {

const userInfoStore = useUserInfoStore();

defineComponent({
  components: {

  },
});


const { t } = useI18n();



return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_tabs, { type: "border-card" }, {
      default: _withCtx(() => [
        (_unref(userInfoStore).userId == 51)
          ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 0,
              label: "簽到&關帳"
            }, {
              default: _withCtx(() => [
                _createVNode(ScheduleCheckMgmt)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(userInfoStore).userId == 51)
          ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 1,
              label: "查詢所有關帳記錄"
            }, {
              default: _withCtx(() => [
                _createVNode(CloseAccountDataMgmt)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(userInfoStore).userId == 51)
          ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 2,
              label: "報表下載"
            }, {
              default: _withCtx(() => [
                _createVNode(ReportMgmt)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})